<div class="wrapper">
  <nav class="side-menu">
    <mat-accordion>
           <mat-expansion-panel
            #panel
            *ngFor="let option of menuSteps; let i = index"
            [hideToggle]="true"
            [expanded]="selectedIndex === i"
            [disabled]="isStepDisabled(option.name)"
            [ngClass]="{ 'selected-panel': selectedIndex === i, 'disabled': isStepDisabled(option.name) }">
        <mat-expansion-panel-header (click)="onStepChange(i, panel)">
          <mat-panel-title>
            <strong>{{ option.name }}</strong>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <!-- Substeps -->
        <div class="submenu" *ngIf="option.subSteps?.length">
          <ng-container *ngFor="let sub of option.subSteps">
            <button mat-button *ngIf="sub.name"            
              [ngClass]="{ 'active-substep': option.name === activeStepName && sub.name === activeSubStepName }"
              (click)="onSubStepClick(i, sub.name, $event)">
              {{ sub.name }}
            </button>
          </ng-container>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </nav>
</div>
